<template>
    <modal :show.sync="show" modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Edit Bank</h3>
        <b-form role="form" @submit.prevent="editBank">
            <b-row>
                <b-col cols="6">
                    <b-form-group label="Bank">
                        <el-select v-model="form.bank_code" filterable placeholder="Select" @change="getBankerListHandler" v-loading="is_loading_bank" :disabled="cannotEdit">
                            <el-option
                            v-for="bank in banks"
                            :key="bank.bank_code"
                            :label="bank.bank_name"
                            :value="bank.bank_code"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Banker">
                        <el-select v-model="form.banker_id" filterable placeholder="Select Banker" v-loading="is_loading_bank" :disabled="cannotEdit" no-data-text="Banker Not Available">
                            <el-option
                            v-for="banker in bankers"
                            :key="banker.id"
                            :label="banker.name"
                            :value="banker.id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Loan Officer">
                        <el-select v-model="form.prod_loan_officer_id" clearable filterable placeholder="Select Loan Officer" :disabled="cannotEdit" @change="loanOfficerDetails">
                            <el-option
                            v-for="loan_officer in userLoanOfficerList"
                            :key="loan_officer.id"
                            :label="loan_officer.name"
                            :value="loan_officer.id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Project Name">
                        <b-form-input
                        v-model="form.project_name"
                        type="text"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <!-- <b-col>
                    <b-form-group label="Loan Margin (%)">
                        <b-form-input
                            v-model="form.loan_margin"
                            type="number"
                            step="0.01"
                            :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col> -->
                <b-col cols="6">
                    <b-form-group label="Loan Amount">
                        <b-form-input
                        v-model="form.loan_amount"
                        type="text"
                        step="0.01"
                        required
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <!-- <b-col cols="6" class="mb-2" v-if="isApprovedBank">
                    <b-form-group label="Approved Loan Amount" class="mb-2">
                        <b-form-input
                        v-model="form.prod_bnk_approved_loan_amount"
                        type="text"
                        step="0.01"
                        required
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col> -->
                <b-col cols="6">
                    <b-form-group label="Interest (%)">
                        <b-form-input
                        v-model="form.interest"
                        type="number"
                        step="0.01"
                        required
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Tenure Year">
                        <el-select v-model="form.tenure_years" placeholder="Select" :disabled="cannotEdit">
                            <el-option
                                v-for="num in 35"
                                :key="num"
                                :label="num + ' Years'"
                                :value="num"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Installment">
                        <b-form-input
                        v-model="form.installment"
                        type="number"
                        required
                        step="0.01"
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Bank Outstanding">
                        <b-form-input
                        v-model="form.bank_outstanding"
                        type="number"
                        required
                        step="0.01"
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Cashout Amount">
                        <b-form-input
                        v-model="form.cashout_amount"
                        type="number"
                        required
                        step="0.01"
                        :disabled="cannotEdit"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6"  v-if="checkAppCode('sas')">
                    <b-form-group label="Additional Cost">
                        <b-form-input
                        v-model="form.prod_bnk_add_cost"
                        type="number"
                        step="0.01"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12" v-if="checkAppCode('sas')">
                        <h3 class="mb-4">Arrangement Fee</h3>
                    </b-col>

                    <b-col :cols="!show_agreement_percent ? '12':'9'" v-if="checkAppCode('sas')">
                    <b-form-group label="Arrangement Fee Amount">
                        <b-form-input
                        v-model="form.arrangement_fee"
                        type="number"
                        step="0.01"
                            ></b-form-input>
                            <div class="d-flex justify-content-end">
                                <a href="javascript:void(0)" @click="show_agreement_percent = !show_agreement_percent">
                                    <small>
                                        <span v-if="!show_agreement_percent">Use</span>
                                        <span v-else>Hide</span>
                                         Percentage</small>
                                </a>
                            </div>
                    </b-form-group>
                </b-col>

                <b-col cols="3" v-if="checkAppCode('sas') && show_agreement_percent">
                    <b-form-group label="%">
                        <b-form-input
                        v-model="form.arrangement_fee_percent"
                        type="number"
                        step="0.01"
                            ></b-form-input>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Arrangement Fee SST">
                        <b-form-radio-group
                            v-model="form.arrangement_fee_sst"
                            :options="SST_OPTIONS"
                        :disabled="cannotEdit"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>

                <b-col cols="12" v-if="checkAppCode('sas')">
                        <b-form-group label="Total Arrangement Fee (RM)">
                        <b-form-input
                        v-model="form.arrangement_fee_amount"
                        type="text"
                        required
                        disabled
                        placeholder="0.00"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Bank Submission Date">
                        <b-form-input
                        v-model="form.prod_bnk_submission_date"
                        type="date"
                        @change="onSubmissionDateChange"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Status">
                        <el-select v-model="form.bank_status" filterable placeholder="Select" :disabled="!checkAccess(['p_product__manage']) && checkAppCode('sas')" @change="handleStatusChange(form.bank_status)">
                            <el-option
                            v-for="(status, index) in status"
                            :key="index"
                            :label="status.status"
                            :value="status.status"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
								<b-col cols="12" v-if="isApprovedBank || (cannotEdit && form.approved_date)">
									<b-form-group label="Approved Date">
											<b-form-input
											v-model="form.approved_date"
											type="date"
											required
											:disabled="cannotEdit"
											></b-form-input>
									</b-form-group>
                </b-col>
                <b-col cols="12" v-if="auth_user.account_info.role_type === 'admin'">
                  <b-form-group label="Invoice Date">
                    <el-date-picker
                      v-model="form.prod_invoice_date"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="Select invoice time and date"
                      :disabled="form.prod_invoice_date_disabled"
                      @input="onInvoiceDateInput"
                    ></el-date-picker>
                  </b-form-group>
                </b-col>
                <!-- <b-col cols="6" class="mx-auto text-center mt-3 pt-2" v-if="auth_user.account_info.role_type === 'admin'"> 
                    <b-form-group>
                        <b-button block variant="outline-primary"
                                    @click="exportToGoogleCalendar(form.prod_invoice_date)" 
                                    class="el-icon-date"
                                    style="cursor: pointer;">
                            Export to Calendar
                        </b-button>
                    </b-form-group>
                </b-col> -->
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_btn">Save</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option , DatePicker  } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import {
  calculateLoanMargin,
  calculateInstallment, 
  calculateLoanAmount,
} from '@/assets/js/calculator.js'
import { useAuthStore } from '@/stores/authStore'
import {BANK_CANNOT_EDIT_STATUS, BANK_APPROVAL_STATUS, BANK_STATUS} from '@/assets/js/status.js'
import {isEqual, cloneDeep} from 'lodash'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import moment from 'moment'
import {SST_OPTIONS} from '@/assets/js/options.js'
import { useMessagingStore } from '@/stores/messagingStore'
import { useNotificationStore } from '@/stores/notificationStore'

export default {
    props:{
        show_edit_bank: Boolean,
        bank: Object,
        product: Object,
        status: Array,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,

    },
    data() {
        return {
            prodSSADetails: null, 
            show_agreement_percent: false,
            prod_invoice_date_disabled: false,
            form:{
                bank_code: '',
                bank_name: '',
                banker_id: '',
                interest: '',
                tenure_years: '',
                bank_status: '',
                loan_amount:'',
                installment:'',
                project_name: '',
                bank_outstanding:'',
                cashout_amount:'',
                arrangement_fee: 0,
                arrangement_fee_any_amount: 0,
                arrangement_fee_amount: 0,
                arrangement_fee_sst: 0,
                prod_bnk_submission_date: null,
                approved_date: null,
                prod_loan_officer_id: '',
                prod_invoice_date: '',
                arrangement_fee_percent: null,
                prod_bnk_approved_loan_amount: '',
                prod_bnk_add_cost:''
            },
            banks:[],
            dsr_bank: null,
            bankers: [],
            is_loading_btn: false,
            is_loading_bank: false,
            bank_status_options: BANK_STATUS,
            update_status_role_ids: [1],
            FeeOptions: [
                { text: '0%', value: '0.00' },
                { text: '2%', value: '2.00' },
                { text: '3%', value: '3.00'},
                { text: '5%', value: '5.00' },
                { text: 'Specify', value: 'Specify' }
            ],
            SST_OPTIONS: SST_OPTIONS,
            next_status: {
                main: null,
                sub: null
            }
        }
    },
    computed: {
        ...mapState(useAuthStore, ['auth_user']),
        ...mapState(useAccessControlStore, ['userBankerList', 'userLoanOfficerList']),
        show: {
            get() {
                return this.show_edit_bank
            },
            set(newVal) {
                this.$emit('update:show_edit_bank', newVal)
            },
        },
        cannotEdit(){
            return BANK_CANNOT_EDIT_STATUS.includes(this.bank.prod_bnk_stage_status) && !this.checkAccess(['p_product__manage'])
        },
        isApprovedBank(){
            return BANK_APPROVAL_STATUS.indexOf(this.form.bank_status) !== -1;
        }
    },
    watch:{
        product:{
            async handler(newVal, oldVal){
                if(!isEqual(newVal, oldVal)){
                    await this.setProductDetail(newVal)
                }
                this.prodSSADetails = newVal.prod_ssa_detail;
            },
            immediate: true,
        },
        // 'form.bank_status': {
        //     handler(newStatus, oldStatus) {

        //         if (newStatus === 'Approved' && newStatus !== oldStatus) {
        //             const selectedSSA = this.prodSSADetails;
        //             if (selectedSSA) {
        //                 this.sendApprovalEmailToSSA(selectedSSA.name, selectedSSA.email);
        //             }
        //         }
        //     },
        //     immediate: false 
        // },
        'form.bank_status': {
            handler(newStatus, oldStatus) {
                if (newStatus === 'Approved' && newStatus !== oldStatus) {
                    this.sendApprovalEmail();
                } 
                else if (newStatus === 'Rejected by Bank' && newStatus !== oldStatus) {
                    this.sendRejectionEmail();
                } 
                else if (newStatus === 'Pending Approval' && newStatus !== oldStatus) {
                    this.sendPendingApprovalEmail();
                }
            },
            immediate: false,
        },
        bank:{
            async handler(newVal, oldVal){
                if(!isEqual(newVal, oldVal)){
                    await this.setForm(newVal)
                    await this.getBanks()
                    await this.getBankerListHandler(cloneDeep(newVal.prod_bnk_code))
                }
            },
            immediate: true,
        },
        'form':{
            handler(newVal){
                // if(this.is_use_loan_amount){
                //     this.form.loan_margin = calculateLoanMargin(newVal.loan_amount, newVal.spa_price)
                // }else{
                //     this.form.loan_amount = calculateLoanAmount(newVal.spa_price, newVal.loan_margin)
                // }
                
                this.form.installment = calculateInstallment(newVal.loan_amount, newVal.interest, newVal.tenure_years)

                if(newVal.loan_amount)
                {
                    this.form.cashout_amount = newVal.loan_amount - this.form.bank_outstanding;
                }

                let sst_fee = parseFloat(newVal.arrangement_fee) * parseFloat(newVal.arrangement_fee_sst) / 100

                if(newVal.arrangement_fee_percent !== null){
                    this.form.arrangement_fee = parseFloat(parseFloat(newVal.loan_amount) * parseFloat(newVal.arrangement_fee_percent) / 100).toFixed(2)
                }

                //set total arragement fee
                let arrangement_fee_amount = parseFloat(newVal.arrangement_fee) + parseFloat(sst_fee)
                if(isNaN(arrangement_fee_amount)){
                    this.form.arrangement_fee_amount = 0
                }else{
                    this.form.arrangement_fee_amount = parseFloat(arrangement_fee_amount).toFixed(2)
                }
            },
            deep: true
        },
        'form.bank_code':{
            handler(newVal){
                this.setBankRate()
            },
        },
    },
    created() {
    // Call the checkInvoiceDateDisabled method when the modal is opened to initialize prod_invoice_date_disabled
    this.$watch("show_edit_bank", (newVal) => {
      if (newVal) {
        this.checkInvoiceDateDisabled();
      }
    });
  },
    methods:{
        ...mapActions(useProductStore, ['getCustomerProducts','getBankersBasedOnBank','checkGenerateCommission','sendEmailToBanker']),
        ...mapActions(useMessagingStore, ['sendEmail']),
        ...mapActions(useNotificationStore, ['createNotification','fetchEmailTemplate', 'fetchNotificationTemplate']),
        async handleStatusChange(newStatus) {
            try {
                // Fetch the notification template using the trigger point 'LEAD_STATUS_CHANGE'
                const notificationTemplate = await this.fetchNotificationTemplate('CASE_STATUS_CHANGE');
                if (notificationTemplate && notificationTemplate.is_active) { 
                let message = notificationTemplate.notif_temp_message

                // Construct the notification content
                let contentNotification = {
                  noti_message: "Case #"+ this.product.prod_id +" : "+message+" "+newStatus,
                  noti_url: window.location.origin + '/casesListings?prod_id=' + this.product.prod_id +'&prod_type='+ this.product.prod_type,
                    microservice_code: 'product',
                    noti_related_type: 'product',
                    noti_related_id: this.product.prod_id,
                };

                // Get recipients from the template
                const recipients = notificationTemplate.notif_temp_receiver.split(',').map(id => parseInt(id.trim(), 10));

                for (const recipient of recipients) {
                          if (!isNaN(recipient)) { // Check if recipient is a valid integer
                            let notification = { ...contentNotification, noti_user_id: recipient };
                            
                            // let notification = { ...contentNotification, noti_user_id: recipients }

                            this.createNotification(notification)
                        }
                }   
              }

                this.notifySuccess('Notification sent successfully.');

            } catch (error) {
                console.error('Failed to send notification:', error);
                this.notifyError('Failed to send notification.');
            }
        },
        async sendEmailToLoanOfficer(loanOfficerName, loanOfficerEmail) {
            const emailData = {
                to: loanOfficerEmail, 
                subject: `New Case Assigned: [ Refinance - ${this.product.prod_id} ]`,
                body: `Dear ${loanOfficerName},\n\nA new case has been assigned to you. Please review the details at your earliest convenience.\n\nThank you,\nFintos Advice Consultancy Sdn Bhd`
            };
            try {
                const response = await axios.post( services.product + 'send-email', emailData , {headers: getHeader()}); // Adjust the API endpoint as per your backend route
                console.log('Email sent successfully:', response);
            } catch (error) {
                console.error('Error sending email:', error);
            }
        },

        loanOfficerDetails() {
            const selectedLoanOfficer = this.userLoanOfficerList.find(officer => officer.id === this.form.prod_loan_officer_id);
            if (selectedLoanOfficer) {
                this.sendEmailToLoanOfficer(selectedLoanOfficer.name ,  selectedLoanOfficer.email);
            }
        },
        async sendPendingApprovalEmail() {
          try {
            const emailTemplate = await this.fetchEmailTemplate('CASE_PENDING_APPROVAL');
            if (emailTemplate && emailTemplate.is_active == 1) {

              const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

              // Prepare the email data
              const emailData = {
                to: recipients, // Array of email addresses
                subject: emailTemplate.notif_temp_title,
                body: emailTemplate.notif_temp_message
                .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
                .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
              };
              
              await this.sendEmail(emailData);
              this.notifySuccess('Pending Approval email sent successfully.');
            }
          } 
          catch (error) {
              console.error('Failed to send email:', error);
              this.errorFunction(error);
          }
        },
        async sendApprovalEmail() {
          try {
            const emailTemplate = await this.fetchEmailTemplate('CASE_APPROVE');
            if (emailTemplate && emailTemplate.is_active == 1) {

                const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

                // Prepare the email data
                const emailData = {
                  to: recipients, // Array of email addresses
                  subject: emailTemplate.notif_temp_title,
                  body: emailTemplate.notif_temp_message
                  .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
                  .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
                };

                await this.sendEmail(emailData);
                this.notifySuccess('Approval email sent successfully.');
              }
            } 
            catch (error) {
                console.error('Failed to send email:', error);
                this.errorFunction(error);
            }
          },
        async sendRejectionEmail() {
          try {
          const emailTemplate = await this.fetchEmailTemplate('CASE_REJECT');
          if (emailTemplate && emailTemplate.is_active == 1) {

          const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

          // Prepare the email data
          const emailData = {
            to: recipients, // Array of email addresses
            subject: emailTemplate.notif_temp_title,
            body: emailTemplate.notif_temp_message
            .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
            .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
          };

              await this.sendEmail(emailData);
              this.notifySuccess('Rejection email sent successfully.');
            }
          } 
          catch (error) {
              console.error('Failed to send email:', error);
              this.errorFunction(error);
          }
        },
        // async sendApprovalEmailToSSA(ssaName, ssaEmail) {
        //     const refinanceId = this.product.prod_id;
        //     const emailData = {
        //         to: ssaEmail,
        //         subject: `Loan Approval Notification: [ Refinance - ${refinanceId} ]`,
        //         body: `Dear ${ssaName},\n\nWe are pleased to inform you that the application for refinance ${refinanceId} has been approved. Final approval details can be referred to in the system's last update.\n\nBest regards,\nFintos Advice Consultancy Sdn Bhd`
        //     };
        //     try {
        //         const response = await axios.post(services.product + 'send-email', emailData, { headers: getHeader() });
        //         console.log('Email sent successfully:', response);
        //     } catch (error) {
        //         console.error('Error sending email:', error);
        //     }
        // },
        async sendEmailToSSA(ssaName, ssaEmail) {
            const emailData = {
                to: ssaEmail, 
                subject: `Application Update Processing with [ Refinance - ${this.product.prod_id} ]`,
                body: `Dear ${ssaName},\n\nWe are pleased to inform that your client - ${this.product.prod_customer_name} application is currently being processed by ${this.form.bank_name} at ${this.form.prod_bnk_submission_date}.\n\nBest regards,\nFintos Advice Consultancy Sdn Bhd`
            };
            try {
                const response = await axios.post(services.product + 'send-email', emailData , {headers: getHeader()});
                console.log('Email sent successfully:', response);
            } catch (error) {
                console.error('Error sending email:', error);
            }
        },

        async onSubmissionDateChange() {
            const selectedSSA = this.prodSSADetails;
            // console.log(selectedSSA.name, selectedSSA.email);
            if (selectedSSA) {
                this.sendEmailToSSA(selectedSSA.name, selectedSSA.email);
            }
        },
        onInvoiceDateInput(newValue, oldValue) {
            // Only proceed if the new value is different from the old value
            if (newValue !== oldValue) {
                // Display confirmation dialog
                const confirmed = confirm("Please confirm your decision: Once the invoice date is set, it cannot be changed. Proceed with Yes or cancel to quit and set later.");

                if (!confirmed) {
                    // User canceled the confirmation, revert to the old value
                    this.form.prod_invoice_date = oldValue;
                } else {
                    // User confirmed, disable the input
                    this.$set(this.form, 'prod_invoice_date_disabled', true);
                }
            }
        },    
        checkInvoiceDateDisabled() {
          this.form.prod_invoice_date_disabled = !!this.form.prod_invoice_date;
        },
        setBankRate(){
            let dsr_bank = this.banks.find(bank => bank.bank_code == this.form.bank_code)
            if(dsr_bank){
                if(!this.form.interest){
                    this.form.interest = dsr_bank.bank_loan_interest_rate
                }
                if(!this.form.tenure_years){
                    this.form.tenure_years = dsr_bank.bank_loan_tenure_year
                }
                this.dsr_bank = dsr_bank
            }else{
                this.form.interest = ''
                this.form.tenure_years = ''
            }
        },
        async setForm(data){
            this.form.bank_code = data.prod_bnk_code
            this.form.bank_name = data.prod_bnk_name
            this.form.banker_id = data.prod_bnk_banker_id
            this.form.interest = data.prod_bnk_interest
            this.form.loan_amount = data.prod_bnk_loan_amount
            this.form.installment = data.prod_bnk_installment
            this.form.tenure_years = data.prod_bnk_tenure
            this.form.bank_status = data.prod_bnk_stage_status
            this.form.prod_bnk_submission_date = data.prod_bnk_submission_date ? moment(data.prod_bnk_submission_date).format('YYYY-MM-DD') : ''
            this.form.approved_date = data.prod_bnk_approved_date
            this.form.arrangement_fee_percent = null
            this.show_agreement_percent = false
            this.form.prod_bnk_approved_loan_amount = data.prod_bnk_approved_loan_amount
            this.form.prod_bnk_add_cost = data.prod_bnk_add_cost
            this.form.arrangement_fee = data.prod_bnk_agreement_rate
            this.form.arrangement_fee_sst = data.prod_bnk_agreement_rate_sst
            this.form.arrangement_fee_amount = data.prod_bnk_agreement_fees
        },
        async setProductDetail(data){
            this.form.project_name = data.product_detail.prod_ref_project_name
            this.form.bank_outstanding = data.product_detail.prod_ref_bank_outstanding
            this.form.cashout_amount = data.product_detail.prod_ref_cashout_amount
            // this.form.arrangement_fee_amount = data.product_detail.prod_ref_agreement_fees
            // this.form.arrangement_fee = data.product_detail.prod_ref_agreement_rate
            // this.form.arrangement_fee_sst = data.product_detail.prod_ref_agreement_rate_sst
            this.form.prod_loan_officer_id = data.prod_loan_officer_id
            this.form.prod_invoice_date = data.prod_invoice_date

        },
        async getBanks(){
            this.is_loading_bank = true
            axios.get(services.customer + 'customer/' + this.product.prod_customer_id +'/dsr.eligibilities?formula=RF', {headers: getHeader()})
            .then(res=>{
                    this.banks = res.data.data.bank_eligibilities
                    this.is_loading_bank = false
                })
                .catch(e =>{
                    this.errorFunction(e)
                })
        },
        async getBankerListHandler(bank_code){
            this.is_loading_bank = true
						try{
								this.bankers = cloneDeep(this.userBankerList);
								this.bankers = await this.getBankersBasedOnBank(cloneDeep(this.userBankerList), bank_code, this.product.prod_type);
								let banker = this.bankers.find(bBank => bBank.id == this.form.banker_id)
                if(!banker){
                    this.form.banker_id = null
                }
								let selected_bank = this.banks.find(bank => bank.bank_code == bank_code)
								if(!_gHlp.isEmpty(selected_bank)){
                    this.form.bank_name = selected_bank.bank_name
                }

								this.is_loading_bank = false
            }catch(e){
								this.is_loading_bank = false
                _gNotif.errorFunction(e)
            }
        },
        editProductDetail(bank){
            let data = {
                "prod_agent_id": this.product.prod_agent_id,
                "prod_agent_username" : this.product.prod_agent_username,
                "prod_customer_basket" : this.product.prod_customer_basket,
                "prod_customer_id" : this.product.prod_customer_id,
                "prod_customer_name" : this.product.prod_customer_name,
                "prod_type": this.product.prod_type,
                "prod_main_status": this.next_status.main,
                "prod_status": this.next_status.sub,
                "prod_loan_officer_id": this.form.prod_loan_officer_id,
                "prod_invoice_date": this.form.prod_invoice_date,
                "product_detail" : {
                    "prod_ref_stage_status": this.next_status.main,
                    "prod_ref_project_name": this.form.project_name,
                    "prod_ref_loan_amount":this.form.loan_amount,
                    "prod_ref_interest":this.form.interest,
                    "prod_ref_tenure":this.form.tenure_years,
                    "prod_ref_installment":this.form.installment,
                    "prod_ref_bank_outstanding":this.form.bank_outstanding,
                    "prod_ref_cashout_amount":this.form.cashout_amount,
                    // "prod_ref_agreement_fees": this.form.arrangement_fee_amount,
                    // "prod_ref_agreement_rate": this.form.arrangement_fee,
                    // "prod_ref_agreement_rate_sst": this.form.arrangement_fee_sst
                },
            }
            axios.post(services.product + 'product/' + this.product.prod_id, data, {headers: getHeader()})
                .then(res=>{
										if(this.form.banker_id != this.bank.prod_bnk_banker_id){
											this.sendEmailToBanker(bank,res.data)
										}
                    this.resetField()
                    if (!this.disableInvoiceDate) {
                        this.disableInvoiceDate = true;
                    }
                    this.is_loading_btn = false
                    this.$emit('update:show_edit_bank', false)
                    caseEventBus.$emit('refresh-cases')
                    this.notifySuccess('<b>Bank</b> - Successfully Updated.')
										this.checkGenerateCommission(this.product,'mortgage_status',this.form.bank_status)
                })
                .catch(e=>{
                    this.is_loading_btn = false
                    this.errorFunction(e)
                })
        },
        determineNextCaseStatus(current_status){
            const currentStatus = this.status.find((item) => item.status === current_status.status)

            this.next_status.main = currentStatus.parent.status
            this.next_status.sub = currentStatus.status

            // if have multiple submission, loop through all banks and find which order is higher 
            if(this.product.product_banks.length > 1){
                const product_banks = this.product.product_banks.filter((item) => item.prod_bnk_id != this.bank.prod_bnk_id)
                product_banks.forEach(product_bank => {
                    const product_bank_status = this.status.find((item) => item.status === product_bank.prod_bnk_stage_status)
                    if(product_bank_status){
                        if(product_bank_status.parent.order > currentStatus.parent.order){
                            this.next_status.main = product_bank_status.parent.status
                            this.next_status.sub = product_bank_status.status
                        }
                    }
                });
            }
        },
        editBank(){
            const status = this.status.find((item) => item.status === this.form.bank_status)

            if(!status || !status.parent){
                this.errorFunction(null, 'Status could not be found.')
                return
            }

            this.determineNextCaseStatus(status)

            let data = {
                "prod_bnk_id": this.bank.prod_bnk_id,
                "prod_bnk_name": this.form.bank_name,
                "prod_bnk_prod_id": this.bank.prod_bnk_prod_id,
                "prod_bnk_logo_url": this.dsr_bank ? this.dsr_bank.bank_image_url : this.bank.prod_bnk_logo_url,
                "prod_bnk_banker_id": this.form.banker_id ?? null,
                "prod_bnk_stage_status": status.status,
                "prod_bnk_loan_amount": this.form.loan_amount,
                "prod_bnk_interest": this.form.interest,
                "prod_bnk_margin": this.form.loan_margin,
                "prod_bnk_tenure": this.form.tenure_years,
                "prod_bnk_gross_cashback": null,
                "prod_bnk_installment": this.form.installment,
                "prod_bnk_code": this.form.bank_code,
                "prod_bnk_submission_date": this.form.prod_bnk_submission_date,
                "prod_bnk_lo_sign_date": this.bank.prod_bnk_lo_sign_date,
                "prod_bnk_approved_date": this.form.approved_date,
                "prod_bnk_approved_loan_amount": this.form.prod_bnk_approved_loan_amount,
                "prod_bnk_add_cost": this.form.prod_bnk_add_cost,
                // "prod_ref_agreement_rate": this.form.arrangement_fee,
                // "prod_ref_agreement_rate_sst": this.form.arrangement_fee_sst,
                // "prod_ref_agreement_fees": this.form.arrangement_fee_amount,
                "prod_bnk_agreement_rate": this.form.arrangement_fee,
                "prod_bnk_agreement_rate_sst": this.form.arrangement_fee_sst,
                "prod_bnk_agreement_fees": this.form.arrangement_fee_amount,
            }

            this.is_loading_btn = true
            axios.post(services.product + 'product-bank/' + this.bank.prod_bnk_id, data, {headers: getHeader()})
                .then(res=>{
                    this.editProductDetail(res.data)
                })
                .catch(e =>{
                    this.errorFunction(e)
                })
        },
        resetField(){
            this.dsr_bank = null
        },
        exportToGoogleCalendar(appointmentAt) {
            const caseName = this.product.prod_customer_name

            // Check if appointmentAt is not empty
            if (!this.isEmpty(appointmentAt)) {
                // Format the appointment date for the Google Calendar link
                const formattedDate = this.formatGoogleCalendarDate(appointmentAt);
                // Create the Google Calendar link
                const googleCalendarLink = this.generateGoogleCalendarLink(formattedDate, caseName);
                // Open the link in a new tab
                window.open(googleCalendarLink, '_blank');
            }
        },

        formatGoogleCalendarDate(appointmentAt) {
            const date = new Date(appointmentAt);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');

            return `${year}${month}${day}T${hours}${minutes}${seconds}`;
        },

        generateGoogleCalendarLink(formattedDate, caseName) {
            // Generate Google Calendar link with necessary details
            const googleCalendarLink = `https://www.google.com/calendar/render?action=TEMPLATE&dates=${formattedDate}/${formattedDate}&text=${caseName}&details=Your%20appointment%20description%20goes%20here.&location=Appointment%20Location&sf=true&output=xml`;

            return googleCalendarLink;
        },
    }
}
</script>